import axios from "axios";
import { getClientSecrets } from "../store/actions/authActions";
const isLocalhost = false
// const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

const API_URL = isLocalhost ? "http://localhost:3000/api" : "https://office.4thcode.io/api";
const API_URL_CUSTOM = isLocalhost ? "http://localhost:3000/custom" : "https://office.4thcode.io/custom";
const CONCIERGE_URL = isLocalhost ? "http://localhost:3003" : "https://site--concierge--84jmr4zs8gs6.code.run";


// Helper to attach the token interceptor
function attachAuthInterceptor(instance) {
  instance.interceptors.request.use(
    (config) => {
      const cs = getClientSecrets();
      const token = cs.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
}

// Helper to create an Axios instance with interceptor
function createApiInstance(baseURL) {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });
  attachAuthInterceptor(instance);
  return instance;
}

export const api = createApiInstance(API_URL);
export const customApi = createApiInstance(API_URL_CUSTOM);
export const conciergeApi = createApiInstance(CONCIERGE_URL);